import React, { useState, Fragment } from 'react';
import { Container, Typography, Box, Button, List, ListItem, ListItemText, IconButton, LinearProgress } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import Layout from '../../components/layouts/Layout';

const packageTypes = [
  { title: 'Drone Delivery', description: 'Send parcel to people via drone service' },
  { title: 'Documents', description: 'Send documents to people' },
  { title: 'Medium Size', description: 'Send parcel up to 10kg in weight to people' },
  { title: 'Big Size', description: 'Send parcel up to 100kg in weight to people' },
];

const PackageSelection = ({ onNext }) => {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="p" color="#dd4a48" fontWeight="bold">
          STEP: 1 OF 7
        </Typography>
        <Typography variant="h5" fontWeight="bold" sx={{ mt: 1, mb: 2 }}>
          New Package Order
        </Typography>
        <LinearProgress variant="determinate" value={14} sx={{ height: 8, borderRadius: 4, mb: 4 }} />
      </Box>

      <Box>
        <Typography variant="h6" fontWeight="bold" color={'black'} sx={{ mb: 2 }}>
          Package Type
        </Typography>
        <List sx={{ width: '100%' }}>
          {packageTypes.map((pkg, index) => (
            <ListItem 
              key={index} 
              sx={{
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                p: 2,
                cursor: 'pointer',
                '&:hover': { borderColor: 'primary.main' }
              }}
            >
              <IconButton sx={{ mr: 2 }}>
                <ImageIcon fontSize="large" color="disabled" />
              </IconButton>
              <ListItemText
                primary={<Typography variant="subtitle2" fontWeight="bold" color={'black'}>{pkg.title}</Typography>}
                secondary={<Typography variant="body2" color="textSecondary">{pkg.description}</Typography>}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Box sx={{ textAlign: 'right', mt: 4 }}>
        <Button variant="contained" color="primary" size="large" onClick={onNext}>
          Next ➔
        </Button>
      </Box>
    </Container>
  );
};

const DeliveryInfo = ({ onPrevious, onNext }) => {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="p" color="#dd4a48" fontWeight="bold">
          STEP: 2 OF 7
        </Typography>
        <Typography variant="h5" fontWeight="bold" sx={{ mt: 1, mb: 2 }}>
          Delivery Info
        </Typography>
        <LinearProgress variant="determinate" value={28} sx={{ height: 8, borderRadius: 4, mb: 4 }} />
      </Box>

      <Box>
        <Typography variant="h6" fontWeight="bold" color={'black'} sx={{ mb: 2 }}>
          Delivery Info
        </Typography>
        <List sx={{ width: '100%' }}>
          <ListItem sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ListItemText primary="From" sx={{mr:2}}/>
            <select style={{ padding: '8px', width: '100%' }}>
              <option>-- Select --</option>
              {/* Add options dynamically here */}
            </select>
          </ListItem>
          <ListItem sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ListItemText primary="Stop" sx={{mr:2}}/>
            <select style={{ padding: '8px', width: '100%' }}>
              <option>-- Select --</option>
              {/* Add options dynamically here */}
            </select>
          </ListItem>
        </List>
        <Button variant="outlined" color="primary" sx={{ mt: 2 }}>
          + Add New Stop
        </Button>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button variant="contained" color="secondary" onClick={onPrevious}>Previous</Button>
        <Button variant="contained" color="primary" onClick={onNext}>Next ➔</Button>
      </Box>
    </Container>
  );
};

const NewPackageOrder = () => {
  const [step, setStep] = useState(1);

  const handleNext = () => setStep(step + 1);
  const handlePrevious = () => setStep(step - 1);

  return (
    <Fragment>
      <Layout title="New Package Order" logo="/assets/images/logo.jpeg">
        {step === 1 ? (
          <PackageSelection onNext={handleNext} />
        ) : (
          <DeliveryInfo onPrevious={handlePrevious} onNext={handleNext} />
        )}
      </Layout>
    </Fragment>
  );
};

export default NewPackageOrder;
